module.exports = __webpack_public_path__ + "assets/img/4_116_big.8f5cad21.jpg";